<template>
  <a-modal
      title="补录或指定专家须知"
      :width="960"
      :visible="visible"
      :maskClosable="false"
      @cancel="$emit('cancel')"
      :confirmLoading="loading"
      destroyOnClose
      :footer="null">
    <p style="text-indent: 2em">具有下列情况之一的，因情况紧急，需要即时实施的，经市应急管理部门批准，可以根据工作需要，指定若干名专家提供技术服务，事后应当按照规定程序补办相关手续：</p>
    <p style="text-indent: 2em">（一）需要应对生产安全事故和自然灾害事件救援处置和调查评估的；</p>
    <p style="text-indent: 2em">（二）需要排除重大风险隐患的；</p>
    <p style="text-indent: 2em">（三）本级政府和上级部门组织开展的检查督导等工作需要临时选取专家参与的；</p>
    <p style="text-indent: 2em">（四）其他紧急情况或突发事件需要即时处置的。</p>
    <a-divider/>
    <div style="text-align: center">
      <a-space>
        <a-progress type="circle" :width="30"  :percent="per" />
        <a-button style="width: 150px" :disabled="isShow" type="primary" :loading="saveLoading" @click="onSubmit">{{showName}}</a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script>

export default {
  name: 'AppointPactModal',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  created () {

  },
  data () {
    return {
      loading: false,
      saveLoading: false,
      isShow: true,
      count: 10,
      times: null,
      showName: '确认看清须知',
      per: 0
    }
  },
  methods: {
    onStartLoadData () {
      this.count = 10
      this.per = 0
      this.isShow = true
      this.showName = '确认看清须知'
      this.timeStart()
    },
    onSubmit () {
      this.$emit('success')
    },
    timeStart () {
      this.times = setInterval(() => {
        this.seconds -= 1
        this.butTime()
      }, 500)
    },
    butTime () {
      this.count--
      this.per += 10
      if (this.count <= 0) {
        this.isShow = false
        this.showName = '前往录入'
        clearInterval(this.times)
      }
    }
  }
}
</script>

<style scoped>

</style>
